"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgCarport24 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", role: "img" }, props, { children: (0, jsx_runtime_1.jsxs)("g", __assign({ fill: "none", fillRule: "evenodd" }, { children: [(0, jsx_runtime_1.jsx)("path", { fill: "none", d: "M0 0h24v24H0z" }), (0, jsx_runtime_1.jsx)("path", { d: "M5.5 18.65V7.477l13-2.127m-.504 11.292v1.125c0 .208-.213.376-.476.376h-1.426c-.263 0-.475-.168-.475-.376v-1.125m-5.33 0v1.125c0 .208-.213.376-.476.376H8.387c-.263 0-.475-.168-.475-.376v-1.125m1.08-1.512h1.584m4.735 0h1.585m1.1-1.577-1.57-3.242a.423.423 0 0 0-.384-.232H9.865a.423.423 0 0 0-.383.232l-1.57 3.242v3.089h10.084v-3.089Zm-10.084.054h10.084", stroke: "currentColor" })] })) }))); };
exports.default = SvgCarport24;
